import React from 'react';
import './NocListHeader.css';

export const NocListHeader = () => {

    return(
        <>
            <div className = "noc__list--header">
                <p>Alert Status</p>
                <p>Company</p>
                <p>Action</p>
            </div>
        </>
    );
};